import { CreateUserDto } from '@shared/common/user/create-user.dto';
import { IsUnique } from '@/modules/core/decorators/is-unique.decorator';
import { userApi } from './user.api';

export class FrontCreateUserDto extends CreateUserDto {
    @IsUnique(async (text: string, originalText: string) => {
        if (text) {
            const emailAvailable = await userApi.isEmailAvailable(text);
            return emailAvailable || (originalText === text);
        }

        return true;
    })
    public email!: string;
}
